<template>
  <div class="loader_overlay">
    <div class="loader">
      <div class="icon">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="24px"
          height="30px"
          viewBox="0 0 24 30"
          style="enable-background:new 0 0 50 50;"
          xml:space="preserve"
        >
          <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
            <animate
              attributeName="opacity"
              attributeType="XML"
              values="0.2; 1; .2"
              begin="0s"
              dur="1s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="height"
              attributeType="XML"
              values="10; 20; 10"
              begin="0s"
              dur="1s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="y"
              attributeType="XML"
              values="10; 5; 10"
              begin="0s"
              dur="1s"
              repeatCount="indefinite"
            />
          </rect>
          <rect x="8" y="10" width="4" height="10" fill="#333" opacity="0.2">
            <animate
              attributeName="opacity"
              attributeType="XML"
              values="0.2; 1; .2"
              begin="0.25s"
              dur="1s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="height"
              attributeType="XML"
              values="10; 20; 10"
              begin="0.25s"
              dur="1s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="y"
              attributeType="XML"
              values="10; 5; 10"
              begin="0.25s"
              dur="1s"
              repeatCount="indefinite"
            />
          </rect>
          <rect x="16" y="10" width="4" height="10" fill="#333" opacity="0.2">
            <animate
              attributeName="opacity"
              attributeType="XML"
              values="0.2; 1; .2"
              begin="0.5s"
              dur="1s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="height"
              attributeType="XML"
              values="10; 20; 10"
              begin="0.5s"
              dur="1s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="y"
              attributeType="XML"
              values="10; 5; 10"
              begin="0.5s"
              dur="1s"
              repeatCount="indefinite"
            />
          </rect>
        </svg>
      </div>
      <div class="text">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: '',
    },
  },

  data() {
    return {};
  },

  computed: {},

  created() {},

  mounted() {},

  beforeUnmount() {},

  methods: {},
};
</script>

<style scoped lang="scss">
.icon {
  margin: 0 15px 0 0;

  svg path,
  svg rect {
    fill: #db841e;
  }
}

.loader_overlay {
  position: fixed;
  overflow: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 200;
  background: #1e2121;
  display: flex;
  align-items: center;
  justify-content: center;

  .loader {
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center;
    // background:#2c3233;
    padding: 12px 20px 10px 20px;
    border-radius: 3px;

    img {
      width: 60px;
      height: 60px;
      margin: 0 0 20px 0;
    }

    .text {
      color: #fff;
      font-size: 20px;
      font-weight: 100;
      margin: 0 0 5px 0;
    }
  }
}
</style>
